import { render, staticRenderFns } from "./SunIcon.vue?vue&type=template&id=6c0c59f3&scoped=true&"
import script from "./SunIcon.vue?vue&type=script&lang=js&"
export * from "./SunIcon.vue?vue&type=script&lang=js&"
import style0 from "./SunIcon.vue?vue&type=style&index=0&id=6c0c59f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c59f3",
  null
  
)

export default component.exports